import { createSelector } from '@reduxjs/toolkit';
import { fetchTeamsRequest } from 'actions';
import { GlobalState } from 'reducers';
import type { Selector, Team } from 'types';

export const getTeams: Selector<Team[]> = (state) => Object.values(state.teams.items);

export const getTeamsWithCounts: Selector<(Team & { count: number })[]> = createSelector(
  [
    (state: GlobalState): GlobalState['envelopes']['filtersCounts'] =>
      state.envelopes.filtersCounts,
    (state: GlobalState): GlobalState['teams']['items'] => state.teams.items,
  ],
  (counts, teams) => {
    const teamsCounts = counts.teams || [];

    return Object.values(teams).map((t) => {
      const count = teamsCounts?.find((c) => c.uuid === t.uuid)?.count || 0;
      return { ...t, count };
    });
  }
);

export const getTeamsLoading: Selector<boolean> = (state) =>
  state.teams.loading.includes(fetchTeamsRequest.toString());

export const getTeamsCount: Selector<number> = (state) => state.teams.count;

export const getTeamsForFilterPills: Selector<Team[]> = (state) => {
  const { filterItems } = state.teams;

  return Object.keys(filterItems).map((uuid) => filterItems[uuid]);
};
